// extracted by mini-css-extract-plugin
export default {"tabs":"index-module_tabs_3c3im","tabsTitleList":"index-module_tabsTitleList_K44Xl","tabTitle":"index-module_tabTitle_-qJ4p"};